import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { FileDown } from 'lucide-react';

import DataTable from '../../components/data_table/DataTable';
import Loader from '../../components/loader/Loader';
import { paymentHistory } from '../../redux/slice/PaymentHistory';
import moment from 'moment';


export default function PaymentList() {
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const paymentListData = useSelector(state => state?.paymentHistory?.data)

    useEffect(() => {
        setLoading(true)
        dispatch(paymentHistory({ navigate })).then((res) => list_res(res))
    }, [])

    const list_res = (res) => {
        if (res?.payload?.status == 200) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const pdf_download = (payment_id) => {
        window.open(process.env.REACT_APP_BASE_URL + payment_id, '_blank');
    }

    const formatDisplayDate = (date) => {
        if (!date) return '-'
        const formattedDate = moment(date).locale('en').format('DD-MMM-YYYY')
        return formattedDate === 'Invalid date' ? '-' : formattedDate
    }

    const exportcolumn = ['id', "order_id",  'paymentdata.payment_id', "plansdata.name",  "linkdata.start_date", "linkdata.expire_date", "order_status"];
    const columnDefs = [
        {
            headerName: 'S.NO.',
            valueGetter: 'node.rowIndex + 1',
            sortable: true,
            filter: false,
            maxWidth: 100,

        },
        // {
        //     headerName: 'INVOICE NO.',
        //     field: 'invoice_no',
        // },
        {
            headerName: 'ORDER ID',
            field: 'order_id',
            filter: false,
        },
        {
            headerName: 'TRANSACTION ID',
            field: 'paymentdata.payment_id',
            filter: false,
        },
        {
            headerName: 'PLAN',
            field: 'plansdata.name',
            suppressMenu: true,
            sortable: true,
            filter: false,
            floatingFilter: false,
            minWidth: 100
        },
        // {
        //     headerName: 'AMOUNT',
        //     field: 'paymentdata.amount',
        //     cellRenderer: params => <span >{params.value ? params.value + " (" + params?.data?.paymentdata?.currency + ") " : '-'}</span>,
        //     minWidth: 120,
        // },
        // {
        //     headerName: 'PLAN',
        //     field: 'plansdata.name',
        //     minWidth: 120,
        // },
       
        // {
        //     headerName: 'COUPON CODE',
        //     colId: 'coupon_code',
        //     valueGetter: params => params.data?.coupon_code || '-',
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     sortable: true,
        //     floatingFilter: false,
        //     maxWidth: 150
        // },
        // {
        //     headerName: 'GST NO.',
        //     colId: 'profiledata.gstnumber',
        //     valueGetter: params => params.data?.profiledata?.gstnumber || '-',
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     sortable: true,
        //     floatingFilter: false,
        // },
        // {
        //     headerName: 'CGST',
        //     colId: 'cgst',
        //     valueGetter: params => params.data?.cgst,
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     sortable: true,
        //     floatingFilter: false,
        //     maxWidth: 90
        // },
        // {
        //     headerName: 'SGST',
        //     colId: 'sgst',
        //     valueGetter: params => params.data?.sgst,
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     sortable: true,
        //     floatingFilter: false,
        //     maxWidth: 90
        // },
        // {
        //     headerName: 'IGST',
        //     colId: 'igst',
        //     valueGetter: params => params.data?.igst,
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     sortable: true,
        //     floatingFilter: false,
        //     maxWidth: 90
        // },
        // {
        //     headerName: 'COMPANY',
        //     colId: 'profiledata.company_name',
        //     valueGetter: params => params.data?.profiledata?.company_name,
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     sortable: true,
        //     floatingFilter: false,
        // },
        // {
        //     headerName: 'ADDRESS',
        //     colId: 'profiledata.address',
        //     valueGetter: params => params.data?.profiledata?.address + ',' + params?.data?.citydata?.city + ',' + params?.data?.statedata?.state + ',' + params?.data?.countrydata?.name,
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     sortable: true,
        //     floatingFilter: false,
        // },
        {
            headerName: 'START DATE',
            field: 'linkdata.start_date',
            valueGetter: params => {
                if (!params.data) return null;
                if (params.data.plan_type === 'biolink') {
                    return params.data.usersdata?.biolink_start_date;
                }
                return params.data.linkdata?.start_date;
            },
            valueFormatter: params => formatDisplayDate(params.value),
            cellRenderer: params => <div>{formatDisplayDate(params.value)}</div>,
            filter: false,
            maxWidth: 130,
        },
        {
            headerName: 'END DATE',
            field: 'linkdata.expire_date',
            valueGetter: params => {
                if (!params.data) return null;
                if (params.data.plan_type === 'biolink') {
                    return params.data.usersdata?.biolink_expire_date;
                }
                return params.data.linkdata?.expire_date;
            },
            valueFormatter: params => formatDisplayDate(params.value),
            cellRenderer: params => <div>{formatDisplayDate(params.value)}</div>,
            filter: false,
            maxWidth: 130,
        },
        {
            headerName: 'ORDER STATUS',
            field: 'order_status',
            pinned: 'right',
            filter: false,
            cellRenderer: params => params.value === 'paid' ? <span style={{ textTransform: 'capitalize' }} className='badge text-bg-success'>{'Success'}</span> : params.value === 'failed' ? <span className='badge text-bg-danger' style={{ textTransform: 'capitalize' }}>{"Failed"}</span> : <span className='badge text-bg-warning' style={{ textTransform: 'capitalize' }}>{"Pending"}</span>,
            maxWidth: 148,
        },
        // {
        //     headerName: 'PAYMENT STATUS',
        //     field: 'paymentdata.payment_status',
        //     valueGetter: params => params.data?.paymentdata?.payment_status || '',
        //     filter: 'agTextColumnFilter',
        //     cellRenderer: params => {
        //         const status = params.data?.paymentdata?.payment_status;
        //         if (status === 'success') return <span style={{ textTransform: 'capitalize' }} className='badge text-bg-success'>Success</span>;
        //         if (status === 'failed') return <span className='badge text-bg-danger' style={{ textTransform: 'capitalize' }}>Failed</span>;
        //         return <span className='badge text-bg-warning' style={{ textTransform: 'capitalize' }}>Pending</span>;
        //     },
        //     suppressMenu: true,
        //     sortable: true,
        //     floatingFilter: false,
        // },
        {
            headerName: 'INVOICE',
            field: 'INVOICE',
            cellRenderer: params => {
                return params?.data?.order_status === 'paid' ?
                    <button className='btn btn-sm btn-secondary'
                        onClick={() => pdf_download(params?.data?.paymentdata?.payment_report)}>
                        <FileDown size={18} />
                    </button>
                    : <div>-</div>
            },
            pinned: 'right',
            maxWidth: 100,
            flex: 0,
            sortable: false,
            filter: false
        }
    ]
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout mb-2'>
                            <h5>Payment History</h5>
                        </div>
                        {loading ?
                            <diV className='d-flex justify-content-center mt-5 pt-5'>
                                <Loader />
                            </diV> :
                            paymentListData && paymentListData.length ?
                                <DataTable
                                    rowData={paymentListData}
                                    columnDefs={columnDefs}
                                    excel={true}
                                    search={true}
                                    exportcolumn={exportcolumn}
                                    height={'65vh'}
                                />
                                :
                                <div className='empty_section text-center'>
                                    <span>DATA NOT FOUND</span>
                                </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
